export enum PatientScreenTypeEnum {
    LimitlesscarePatients = 1,
    PspPatients,
    LcaPatients,
  }
